var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6188 14.3813C1.09452 10.857 1.09452 5.143 4.6188 1.61872L3.38136 0.381287C-0.826338 4.58898 -0.826338 11.411 3.38136 15.6187L4.6188 14.3813Z",
    fill: "#FF553E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3813 1.61872C20.9056 5.143 20.9056 10.857 17.3813 14.3813L18.6188 15.6187C22.8265 11.411 22.8265 4.58898 18.6188 0.381287L17.3813 1.61872Z",
    fill: "#FF553E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90643 4.9064C6.19789 6.61495 6.19789 9.38504 7.90643 11.0936L6.66899 12.331C4.27703 9.93906 4.27703 6.06093 6.66899 3.66897L7.90643 4.9064Z",
    fill: "#FF553E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0936 11.0936C15.8022 9.38504 15.8022 6.61495 14.0936 4.9064L15.3311 3.66897C17.723 6.06093 17.723 9.93906 15.3311 12.331L14.0936 11.0936Z",
    fill: "#FF553E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 6.38769C10.1096 6.38769 9.38765 7.1096 9.38765 8.00013C9.38765 8.89065 10.1096 9.61256 11.0001 9.61256C11.8906 9.61256 12.6125 8.89065 12.6125 8.00013C12.6125 7.1096 11.8906 6.38769 11.0001 6.38769Z",
    fill: "#FF553E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.c94c82ed1b539a427605d7b5feed3a3c.svg";
export { ForwardRef as ReactComponent };